import { Button, Dialog, DialogBody, DialogContent, DialogFooter } from '@civilgrid/ui/components';
import axios from 'axios';
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { validateToken } from '~/api/auth2';
import { logOut as apilogOut } from '../../api/auth2';
import authStore from '../../authStore';
import rootStore from '../../store';
import sessionStore from './store';

const worker = new Worker(new URL('./worker.js', import.meta.url));

export default function TokenValidator() {
  const { isSessionExpired } = useSnapshot(sessionStore);
  const { me } = useSnapshot(rootStore) as typeof rootStore;

  useEffect(() => {
    worker.postMessage('start');
    worker.onmessage = async () => {
      try {
        await validateToken();
      } catch (e) {
        if (axios.isAxiosError(e)) {
          if (e.response?.status === 403) {
            sessionStore.expire();
          } else {
            // could be other issues, don't show dialog just yet
          }
        }
        console.error(e, 'Invalid token');
      }
    };

    return () => {
      worker.postMessage('stop');
    };
  }, []);

  if (!isSessionExpired) {
    return null;
  } else {
    return (
      // Not dismissible, since any dismissal would strand the dead session with no way to log in.
      <Dialog open>
        <DialogContent
          title="Session expired"
          dismissible={false}
          className="z-[110] w-auto min-w-min max-w-[75vw]"
          overlayClassName="z-[100]"
          data-testid="session-expired-dialog"
        >
          <DialogBody className="text-sm">Oops, your session has expired. Please re-login to continue.</DialogBody>
          <DialogFooter>
            <Button
              data-testid="session-expired-login-button"
              onClick={async () => {
                // Survives the document load, unlike authStore's in-memory redirect destination.
                const backTo = encodeURIComponent(window.location.href);
                const email = me?.email;
                try {
                  if (email) {
                    const response = await apilogOut({ email });
                    await authStore.reset();
                    if (response.url) {
                      window.location.href = response.url;
                      return;
                    }
                  } else {
                    await authStore.reset();
                  }
                } catch {
                  await authStore.reset();
                }
                window.location.href = `/login?from_url=${backTo}`;
              }}
            >
              Login
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
